var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vs-button',{staticClass:"mr-2",on:{"click":_vm.zoom}},[_vm._v("zoom in")]),_c('vs-button',{staticClass:"ql-bold",on:{"click":_vm.out}},[_vm._v("zoom out")]),_c('cloud',{attrs:{"data":_vm.words,"fontSizeMapper":_vm.fontSizeMapper}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }